export {default as IconCheckCircle} from './IconCheckCircle';
export {default as IconCheck} from './IconCheck';
export * from './types';



// WEBPACK FOOTER //
// ./src/components/SvgIcon/index.ts